// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  FILEUPLOAD_SET_NULL_LOADING_ERROR,
} from './constants';

export function setNullLoadingError() {
  return {
    type: FILEUPLOAD_SET_NULL_LOADING_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FILEUPLOAD_SET_NULL_LOADING_ERROR:
      return {
        ...state,
        uploadFileError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/fileupload/redux/setNullLoadingError.js